
import { User } from "@twilio/conversations";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { gAPI_Users_By_Id } from "../../constants/APIs";
import { getGroupID, AxiosAPI, getUserID } from "../../helpers/AxiosAPI";

const Intercom = ({ propertyId, email, locale, serviceProvider, propertyName, groupName,userName }) => {

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        })
            .then((res) => {
                if (res.data.userId !== undefined) {
                    res.data.loginDate = moment().date() + moment().month() + moment().year();
                    res.data.serviceProvider = serviceProvider;
                    res.data.propertyName = propertyName;
                    res.data.groupName = groupName;
                    res.data.email = email;
                    res.data.userName = userName;
                    console.log('res',res.data)
                    window.parent.postMessage(res.data, "*");
                }
            });
    });
    const windowMessage = () => {

    }
    return (
        <div>
            {/* {showFrame && 
         <div>
            <iframe src="https://app.bookmebob.com/app/pages/integration?__ug__=53966"></iframe>
        </div>} */}
        </div>
    );
}
const mapStateToProps = ({ settings }) => {

    const {
        locale,
        propertyId,
        serviceProvider,


        email,
        userName,

    } = settings;

    return {

        locale,
        serviceProvider,
        propertyId,

        email,
        userName,

    };
};

const mapActionsToProps = {};

const aap = injectIntl(Intercom);
export default connect(mapStateToProps, mapActionsToProps)(aap);
